import React from "react";
import { Navigate } from "react-router-dom";
import { checkCookie } from "../utils/cookies";

const PrivateRoute = ({ element: Component, ...rest }) => {
  const isAuthenticated = checkCookie();
  return isAuthenticated ? (
    <>
      <Component {...rest} />
    </>
  ) : (
    <Navigate to="/login" />
  );
};

export default PrivateRoute;
